// How the cart summary should present the applied coupon.
//
// Kept as a pure function (no React) so the rule is testable and lives in one
// place instead of being re-derived inline for each summary line.
//
// A plain FREE_SHIPPING coupon takes nothing off the item prices, so
// Cart#coupon_value (= subtotal-before-coupon minus subtotal) is $0 for it and
// the Discount line read "-$0.00" above a "Subtotal after Savings" identical to
// the Subtotal. What the customer actually saves is the shipping fee, so that
// one type gets its own presentation: the Discount line shows the shipping fee
// (from the cart's price list), the redundant subtotal-after-savings line is
// dropped, and the Shipping line strikes out the fee it waived.
//
// The *_WITH_FREE_SHIPPING combos DO discount the item prices, so they keep the
// normal discount lines and share only the shipping-line treatment. Every other
// coupon type is unaffected.
export const couponSummary = (cart) => {
  const couponType = cart?.coupon?.couponType || '';
  const shippingOnly = couponType === 'FREE_SHIPPING';
  // The fee being waived. Cart#shipping ignores the coupon (Cart#api_total is
  // what drops it from the charge), so this is the real pre-coupon fee.
  const waivedShipping = Number(cart?.shipping) || 0;

  // A number is currency-formatted with a leading minus by SummaryItem; the
  // label is for the carts that owe no shipping in the first place (digital-only,
  // appointment, $0 subtotal), where "-$0.00" is exactly what we're avoiding.
  let discountValue = Number(cart?.couponValue) || 0;
  if (shippingOnly) discountValue = waivedShipping > 0 ? waivedShipping : 'Free Shipping';

  return {
    shippingOnly,
    // Waives shipping, alone or alongside a price discount.
    freeShipping: couponType.includes('FREE_SHIPPING'),
    waivedShipping,
    discountValue,
  };
};

export default couponSummary;
